import { TFunction } from '@lyearn/i18n';
import { CheckmarkSquare2Outline, ImageOutline, Shuffle2Outline, TextOutline } from '@lyearn/icons';
import { QuestionTypeEnum } from '@/types/schema';

interface Params {
  t: TFunction;
  questionType: QuestionTypeEnum;
}

type EditingInfo = { Icon: typeof ImageOutline; title: string };

export const getQuestionLimitiedEditingInfo = (params: Params): EditingInfo[] => {
  const { t, questionType } = params;

  switch (questionType) {
    case QuestionTypeEnum.SingleSelect:
    case QuestionTypeEnum.MultiSelect:
    case QuestionTypeEnum.PictureMultipleChoiceQuestion: {
      return [
        {
          Icon: TextOutline,
          title: t('QuizCreator:LimitedEditingModal.QuestionLabel'),
        },
        {
          Icon: ImageOutline,
          title: t('QuizCreator:LimitedEditingModal.MediaLabel'),
        },
        {
          Icon: Shuffle2Outline,
          title: t('QuizCreator:LimitedEditingModal.ShuffleOptionsLabel'),
        },
        {
          Icon: CheckmarkSquare2Outline,
          title: t('QuizCreator:LimitedEditingModal.ChangeCorrectAnswers'),
        },
      ];
    }
    case QuestionTypeEnum.FillInTheBlanks: {
      return [
        {
          Icon: TextOutline,
          title: t('QuizCreator:LimitedEditingModal.FTBLabel'),
        },
      ];
    }
    case QuestionTypeEnum.TrueOrFalse: {
      return [
        {
          Icon: TextOutline,
          title: t('QuizCreator:LimitedEditingModal.TrueOrFalseLabel'),
        },
        {
          Icon: ImageOutline,
          title: t('QuizCreator:LimitedEditingModal.MediaLabel'),
        },
      ];
    }
    case QuestionTypeEnum.MatchTheFollowing: {
      return [
        {
          Icon: TextOutline,
          title: t('QuizCreator:LimitedEditingModal.MTFLabel'),
        },
        {
          Icon: ImageOutline,
          title: t('QuizCreator:LimitedEditingModal.MediaLabel'),
        },
      ];
    }
    default: {
      return [];
    }
  }
};
